import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { FNOLPATheftDetailsPage } from 'gwce-capability-fnol-pa-react-ext';
import React from 'react';
import { withRouter } from 'react-router-dom';

function FNOLRTTheftDetailsPage(props) {
    return <FNOLPATheftDetailsPage {...props} />;

}

FNOLRTTheftDetailsPage.propTypes = wizardProps;
export default withRouter(FNOLRTTheftDetailsPage);
